<script setup>
import { ref, computed } from "vue";
import { useStore } from "vuex";

const store = useStore();

const props = defineProps({
    gear: String
})

const gearIndexLookup = ref({
    "R": 0,
    "r": 0,
    "N": 1,
    "n": 1,
    "1": 2,
    "2": 3,
    "3": 4,
    "4": 5,
    "5": 6
})

const gearLayout = ref(["R", "N", "1", "2", "3", "4", "5", "_"])

</script>

<template>
  <div class = "gear-layout">
    <div class = "next-gear" v-if = "gearIndexLookup[gear]-1 >= 0">{{gearLayout[gearIndexLookup[gear] - 1]}}</div>
    <div class = "main-gear">{{gearLayout[gearIndexLookup[gear]]}}</div>
    <div class = "next-gear" v-if = "gearIndexLookup[gear]+1 < gearLayout.length">{{gearLayout[gearIndexLookup[gear] + 1]}}</div>
  </div>
</template>

<style lang="scss" scoped>

@import '../sass/GlobalClasses';
@import '../sass/Settings';

.gear-layout{
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    .main-gear{
        color: white;
        font-size: vw(35);
        margin-left: vw(10);
        margin-right: vw(10);
    }

    .next-gear{
        color: white;
        font-size: vw(12);
    }
}

</style>
